import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScrollLockService {
  private lockCount = 0;

  lock(): void {
    this.lockCount++;
    document.body.style.overflow = 'hidden';
  }

  unlock(): void {
    this.lockCount = Math.max(0, this.lockCount - 1);
    if (this.lockCount === 0) {
      document.body.style.overflow = '';
    }
  }
}
